/**
 * Responsibility: how old a price is, and when to say so.
 *
 * Shared by the table and the card dialog so the two cannot disagree about
 * what "out of date" means. Search answers from the catalogue, so a figure
 * is as old as the last crawl of that set rather than as old as the request
 * - and the difference between a stale price and a wrong one is entirely
 * whether the page admits which it is showing.
 */

/** Past this, a price is called out rather than shown plainly. */
export const STALE_AFTER_DAYS = 2;

/**
 * Days since these prices were read, or null when nothing recorded it.
 *
 * Null is its own answer and not zero: rows crawled before the timestamp
 * existed have no date, and treating that as "just now" would be the one
 * mistake this whole mechanism is here to prevent.
 */
export function daysOld(priced: string | null): number | null {
  if (!priced) return null;
  const when = Date.parse(priced);
  if (Number.isNaN(when)) return null;
  return (Date.now() - when) / 86_400_000;
}
